import CsiFormData from "csi/action/FormData";
import NewFrom from "csi/table/NewFrom";
import ActionControllerMixin from "csi/wizard/ActionControllerMixin";
import declare from "dojo/_base/declare";

const NewFromFPItem = declare([NewFrom, ActionControllerMixin], {

	SELECT_BOM_PAGE: 0,
	SELECT_ITEMS_PAGE: 1,

	/**
	 *@override
	 * Prepare the data and pass it into the next page
	 */
	onNextPage: function (wizard, currentPage, nextPage, bFinish) {
		const nPage = wizard.getIndexOfPage(nextPage);
		var fd = this.m_formData;
		var bRefresh = false;

		if (nPage == this.SELECT_BOM_PAGE) {
			fd = new CsiFormData(this);
			fd.m_bOmitSelections = true;
			fd.m_bRequireOne = true;
			fd.m_bSelectOne = true;
			fd.setNode(wizard.getViewNode());
		} else if (nPage == this.SELECT_ITEMS_PAGE) {
			// Entering the section items table

			var foodLabelNode = wizard.getFormDataFromPage(currentPage).getSelectedNode();

			// reuse already exist form data if user used back button
			fd = wizard.getFormDataFromPage(nextPage) || wizard.defView.m_formData;

			// if form data node has changed, then reset selections and refresh view
			if (fd.getNode() != foodLabelNode) {
				fd.resetSelections();
				fd.setNode(foodLabelNode);
				bRefresh = true;
			}
		}

		// set form data for next page in wizard and refresh view if necessary
		return (fd && !bFinish) ? wizard.setFormDataToPage(nextPage, fd, bRefresh) : null;
	},

});

export = NewFromFPItem;
